import React from 'react'
import SideBar from '@components/JiaMeng/SideBar'
import { JUKE_PATH_A } from '@constant'

export default () => {
  return (
    <SideBar>
      <div style={{ color: '#333' }}>聚客宝有什么玩法</div>
      <div style={{ color: '#666', marginTop: 10 }}>
        将店铺的营销活动，放在拥有众多新人的婚礼纪App中投放曝光，获取平台流量。
      </div>
      <div style={{ color: '#333', marginTop: 20 }}>聚客宝如何申请</div>
      <div style={{ color: '#666', marginTop: 10 }}>
        1.联系BD购买活动券/活动点 <br />
        2.通过微传单+制作活动页面和封面<br />
        3.提交申请，婚礼纪审核通过即可上线
      </div>

      <a
        style={{ marginTop: 10, display: 'inline-block' }}
        onClick={() => window.open(`${JUKE_PATH_A}/rule`)}
      >
        了解详细规则
      </a>
    </SideBar>
  )
}
